.ct{outline:none;}